import React from "react";
import { IconProps } from "./IconProps";

export const PageNotFound = ({
  size = IconProps.size || 48,
  className = IconProps.className || "text-red-600",
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      width={size}
      height={size}
    >
      <path d="M10.29 3.86L1.82 18a1 1 0 00.86 1.5h18.64a1 1 0 00.86-1.5L13.71 3.86a1 1 0 00-1.72 0z" />
      <path
        fill="#fff"
        d="M12 9a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm0 7a1 1 0 100 2 1 1 0 000-2z"
      />
    </svg>
  );
};
